import React, { Component } from 'react';
import { Container, Grid, Typography, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import labels from '../../constant/labels';

import '../../../../src/portals/Page/LandingPage/LandingPage.css';

import qcimage1 from '../../../images/landing-photo/qc_photo-1.jpg';
import qcimage2 from '../../../images/landing-photo/qc_photo-2.jpg';

class LandingPage extends Component {
    render () {
        return (
            <>
                <div className="banner__wrapper">
                    <Container>
                        <Grid container direction="row">
                            <Grid item xs={12}>
                                <div className="button__container">
                                    <Link to="/track">
                                        <Button size="large" variant="outlined" color="primary">
                                            {labels.VIEW_TRACKING_PAGE}
                                        </Button>
                                    </Link>
                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                </div>

                <Container className="content__wrapper">
                    <Grid container direction="row" className="content__box--container">
                        <Grid item xs={12}>
                            <Grid container direction="row" nowrap="true">
                                <Grid item xs={12} md={5} lg={5}>
                                    <img src={qcimage1} alt="Sample" />
                                </Grid>
                                <Grid item xs={12} md={7} lg={7}>
                                    <div className="content__box">
                                        <Typography component="h1" variant="h6">
                                            As part of the city's ease of doing business and automation initiatives, the Quezon City government on Tuesday has launched a system which allows the delivery of 
                                            business permit right at the applicant's address through the Automatic Document Delivery System (ADDS).
                                        </Typography>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    
                    <Grid container direction="row" className="content__box--container"> 
                        <Grid item xs={12}>
                            <Grid container direction="row" nowrap="true">
                                <Grid item xs={12} md={7} lg={7}>
                                    <div className="content__box">
                                        <Typography component="h1" variant="h6">
                                            All evaluated and completed permits - new businesses, amended, and renewed permits - will be delivered right at the owner's doorsteps.
                                        </Typography>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={5} lg={5}>
                                    <img src={qcimage2} alt="Sample" />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </>
        )
    }
}

export default LandingPage;